<template>
  <div class="expected-Delivery-date_approve">
    <el-form>
      <CustomerScheduleChangeFilling
        ref="customerScheduleChangeFilling"
        v-loading="isLoading"
        is-detail
        :change-type="changeType"
        :application-id="applicationId"
        :status="approveStatus"
        @changeCeddType="handleChangeCeddType"
      />
      <BasicInformation ref="basicInformation" v-loading="isLoading" :tatol-cny="tatolCny" />
      <DetailedInformation
        ref="detailedInformation"
        v-loading="isLoading"
        :change-type="changeType"
        :application-id="applicationId"
        @totalCny="totalCny"
      />
      <OperationRecordHistory :application-id="applicationId" />
    </el-form>
    <RejectPopup v-model="isRejectPopupVisible" @reject="handleReject" />
    <BottomButtonGroup
      is-approve
      @reject="handleOpenRejectPopup"
      @pass="handleSubmit"
      @cancel="handleBack"
    />
  </div>
</template>

<script>
import CustomerScheduleChangeFilling from '../components/CustomerScheduleChangeFilling/index.vue';
import BasicInformation from '../components/BasicInformation.vue';
import DetailedInformation from './components/DetailedInformation.vue';
import OperationRecordHistory from '@/views/ExpectedDeliveryDate/components/OperationRecordHistory.vue';
import BottomButtonGroup from '@/views/ExpectedDeliveryDate/components/BottomButtonGroup.vue';
import RejectPopup from '@/views/ExpectedDeliveryDate/Approve/components/RejectPopup .vue';
import { ceddChangeApprove, getCeddChangeDetail } from '@/API/international';
import { mapState } from 'vuex';

export default {
  name: 'Approve',
  components: {
    BottomButtonGroup,
    RejectPopup,
    OperationRecordHistory,
    DetailedInformation,
    BasicInformation,
    CustomerScheduleChangeFilling
  },
  data () {
    return {
      applicationId: '', // 申请单单号
      taskId: '', // 流程业务Id
      changeType: '',
      isLoading: false,
      approveStatus: '',
      isRejectPopupVisible: false,
      tatolCny: 0

    };
  },
  computed: {
    ...mapState(['isCollapse']),
    // 当前登录人是不是产品供应统筹？
    isProductCoordination () {
      return this.$store.state.user.isSupplyCoordination;
    }
  },
  methods: {
    totalCny (val) {
      this.tatolCny = val;
    },
    // 获取详情数据
    getDetailData () {
      this.isLoading = true;
      // 获取数据
      getCeddChangeDetail(this.applicationId)
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            // 没有权限送到详情
            if (!json.data.approveAuth) {
              this.$router.replace({
                path: '/expectedDeliveryDateDetail',
                query: {
                  applicationId: this.$route.query.applicationId
                }
              });
            }
            this.$refs.customerScheduleChangeFilling.setDefaultFormData(
              json.data
            );
            this.$refs.basicInformation.setDefaultFormData(json.data);
            this.$refs.detailedInformation.setDefaultFormData(json.data.detail);
            this.taskId = json.data.form.taskId;
            this.approveStatus = json.data.base.status;
            this.handleChangeCeddType(json.data.form?.type);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 获取下拉
    getSelectList () {
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_TYPE',
        type: 'changeType'
      });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_ADVANCE',
        type: 'changeAdvance'
      });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_DELAY',
        type: 'changeDelay'
      });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_STATUS',
        type: 'changeStatus'
      });
    },
    // 驳回弹窗
    handleOpenRejectPopup () {
      this.isRejectPopupVisible = true;
    },
    /**
     * 驳回
     * @param approvalOpinion 驳回意见
     */
    handleReject ({ reason: approvalOpinion }) {
      const params = {
        form: {
          taskId: this.$route.query.taskId,
          approvalOpinion,
          isPass: false
        },
        base: this.$refs.basicInformation.getFormData()
      };
      const detail = this.$refs.detailedInformation.getFormData('reject');
      if (!detail) return false;
      params.detail = detail;
      ceddChangeApprove(params)
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('驳回成功');
            this.$router.replace({
              path: '/expectedDeliveryDateApproveList'
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 通过
    handleSubmit () {
      const submit = () => {
        const params = {
          form: {
            taskId: this.$route.query.taskId,
            approvalOpinion: '',
            isPass: true
          },
          base: this.$refs.basicInformation.getFormData()
        };
        const detail = this.$refs.detailedInformation.getFormData();
        if (!detail) return false;
        params.detail = detail;
        ceddChangeApprove(params)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('审批成功');
              this.$router.replace({
                path: '/expectedDeliveryDateApproveList'
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      };

      const productList = this.$refs.detailedInformation.getFormData();
      if (!productList) return false;
      const hasControl = productList.find((item) => item.isControlled);
      // 如果是供应统筹并且是提前的情况下， 校验是否存在受控产品， 存在就打开提示
      if (this.isProductCoordination && this.changeType === 'advance' && hasControl) {
        this.$confirm('客期提前包含受控产品，请确认是否同意', '受控提示', {
          confirmButtonText: '同意',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            submit();
          })
          .catch(() => {});
      } else {
        submit();
      }
    },
    // 切换类型
    handleChangeCeddType (type) {
      this.changeType = type;
    },
    handleBack () {
      this.$router.replace({
        path: '/expectedDeliveryDateApproveList'
      });
    }
  },
  mounted () {
    this.$route.query.applicationId &&
      (this.applicationId = this.$route.query.applicationId);
    this.getSelectList();
    this.getDetailData();
  }
};
</script>

<style scoped lang="scss">
.expected-Delivery-date_approve {
  margin-bottom: 60px;
  :deep(.rj-page-card) {
    min-width: 860px;
  }
}
</style>
